/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Costs_TitleInputs */

const en_directory_ai_tools_costs_title = /** @type {(inputs: Directory_Ai_Tools_Costs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What a video costs`)
};

const zh_directory_ai_tools_costs_title = /** @type {(inputs: Directory_Ai_Tools_Costs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每条视频的费用`)
};

/**
* | output |
* | --- |
* | "What a video costs" |
*
* @param {Directory_Ai_Tools_Costs_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_costs_title = /** @type {((inputs?: Directory_Ai_Tools_Costs_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Costs_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_costs_title(inputs)
	return zh_directory_ai_tools_costs_title(inputs)
});
export { directory_ai_tools_costs_title as "directory.ai_tools.costs.title" }